import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, borderRadius, colors, spacing } = useTheme();

  return {
    base: () => css`
      height: 100%;
      display: block;
      grid-template-rows: auto 1fr;
      grid-template-columns: 100%;
    `,
    wrapper: () => css`
      ${breakpoints.m} {
        padding: 0;
      }
      ${breakpoints.l} {
        margin: 0 auto;
      }
    `,
    score: css`
      max-width: 13.875rem;
      height: 48px;
      background-color: ${colors.lightGrey};
      border-radius: ${borderRadius.l};
      display: grid;
      grid-gap: 0.875rem;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      padding: 0.9rem ${spacing.s} ${spacing.s};
      display: none;
    `,
    title: css`
      color: ${colors.navy};
      word-spacing: ${spacing.xs};

      span {
        font-weight: bold;
      }
    `,
    contactForm: css`
      font-size: 1rem;
      background-color: ${colors.buttonRed};
      color: ${colors.white};
      text-transform: uppercase;
      &:not(:disabled):not(:focus-visible) {
        &:hover,
        &:focus {
          background-color: ${colors.buttonBlue};
          color: ${colors.white};
        }
      }
      ${breakpoints.s} {
        &:focus-visible {
          outline: none;
          border: 2px solid ${colors.border_black};
          color: ${colors.border_black};
          background-color: ${colors.skip_yellow};
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
        }
        &:focus-visible:hover {
          color: ${colors.border_black};
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
        }
      }
      @media screen and (max-width: 991px) {
        font-size: 0.875rem;
      }
    `,
    teamListDetails: css`
      margin-bottom: 10rem;
    `,

    pageView: css`
      display: block;
      grid-template-columns: 1fr 325px;
      grid-gap: 3.375rem;
      margin: 0 auto;
      max-width: 951px;
      width: 100%;
      ${breakpoints.m} {
        display: grid;
      }
      ${breakpoints.l} {
        display: grid;
      }
      @media screen and (min-width: 1281px) {
        margin-left: 17.5rem;
      }
    `,
    pageViewRight: css`
      order: 2;
    `,
    pageViewLeft: css`
      @media screen and (min-width: 1601px) {
        margin-top: 2.5rem;
        margin-left: -2rem;
      }
    `,
  };
};
